import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import React from "react";
import {objectsAttributes} from "../../models/objects";
import Button from "../common/Button";
import SocialMediaButtonGroup from "../VermietungBuchungAnfragenForm/AnfrageFormComponents/SocialMediaButtonGroup";

interface VerkaufsAnfrageFormProps {
	object: objectsAttributes;
	disabled?: boolean;
}

function VerkaufsAnfrageForm({object, disabled}: VerkaufsAnfrageFormProps) {
	const router = useRouter();
	const {t} = useTranslation();

	function handleExposeAnfragen() {
		router.push("/verkauf/verkaufsanfrage?objectId=" + object?.id);
	}

	return (
		<div
			className={`flex w-full`}
		>
			<div className="relative w-full">
				<div className="flex flex-col absolute top-0 left-0 right-0 -mt-[30px] w-full bg-white max-w-[90%] mx-auto rounded-[20px] shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)]">
					{object.status_sale !== "Sold" &&
						<div className="flex flex-col whitespace-nowrap px-5 xl:px-10 pt-4 pb-5 xl:pt-8 xl:pb-10">
							<p className="line-through text-leo-text-gray text-3xl">
								{object?.sales_price_gross_eur_special &&
									object?.sales_price_gross_eur.toLocaleString(router.locale) +
									" €"}
							</p>
							<div className="flex flex-row gap-2 items-end justify-center">
								<p className="text-leo-blue font-bold text-[32px] xl:text-[40px]">
									{parseInt(
										object?.sales_price_gross_eur_special
											? object.sales_price_gross_eur_special
											: object?.sales_price_gross_eur.toString()
									).toLocaleString(router.locale) + " €"}
								</p>
								<p className="text-leo-blue text-[14px] xl:text-lg font-bold uppercase">
									{t("components.verkaufsAnfrageForm.salesPrice")}
								</p>
							</div>
							
						</div>
					}
					{object.status_sale === "Sold" &&
						<p className="text-leo-orange text-lg font-bold uppercase">
							{t(`common.saleStatus.${object.status_sale}`)}
						</p>
					}
					<div className="bg-[#e0f5fc] flex flex-col xl:flex-row justify-between items-center gap-4 px-8 py-4 xl:px-12 xl:py-8 rounded-br-[20px] rounded-bl-[20px]">
						<SocialMediaButtonGroup source="contact_sale"/>

						{!(object.status_sale === "Sold" || router.pathname.includes("verkaufsanfrage")) && (
						<Button
								text={t("components.verkaufsAnfrageForm.requestExpose")}
								transparent={false}
								border={false}
								height={"h-[43px]"}
								padding={"px-4"}
								className="rounded-[10px] text-[12px] font-bold leading-normal bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent"
								onClick={handleExposeAnfragen}
								disabled={disabled}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default VerkaufsAnfrageForm;
